import React, { useEffect, useState } from "react";
// Models
import { Convocatoria } from "../../models/ConvocatoriasModel/convocatoria.model";
// styled components
import { Image } from "antd";
// images
import Imageconvocatoria from "../../assets/landing/logo2026.png";
import ImageconvocatoriaSm from "../../assets/mujeres/logosm2026.jpg";
import apiConvocatorias from "../../api/Convocatorias/api-convocatorias";
import apiMaestras from "../../api/Maestras/api-maestras";
import { useEncrypt } from "../../hooks/useEncrypt";
import moment from "moment";

interface IProps {
  convocatorias: Convocatoria;
  role: "jurados" | "participantes";
  showExpression?: boolean;
  supportSMImage?: boolean;
}

export const PostulacionBannerShared: React.FC<IProps> = (props: IProps) => {
  const [LineasConvocatorias, setLineasConvocatorias] = useState([]);

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  };

  const getFilterLineaConvocatoria = (idLineaConvocatoria: number) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) {
      return valueFilter[0].nombre;
    }
  };

  const [convocatoria, setConvocatoria] = useState<any>({
    area: [],
    fechas: [],
    linea_estrategica: null,
    nombre_convocatoria: null,
    entidad: null,
  });

  const { decrypt } = useEncrypt();
  const idConvocatoria = decrypt(localStorage.getItem("idConvocatoriaPostulacion"));

  useEffect(() => {
    consultarConvocatoria();
    getLineasConvocatorias();
  }, []);

  const consultarConvocatoria = async () => {
    const { data } = await apiConvocatorias.infoBannerPostulacionConvocatoria(
      idConvocatoria
    );
    setConvocatoria(data);
  };

  const showSMImage = props.supportSMImage && convocatoria.entidad === "SM";

  const formatFechaRango = (clave: string, formato: string): string | null => {
    const fechas: any[] = convocatoria?.fechas ?? [];
    if (!fechas.length) return null;
    const matches = fechas.filter((d: any) => d.clave === clave);
    if (!matches.length) return null;
    const inicio = moment(matches[0].valormin.substring(0, 10)).format(formato);
    const maxMoment = moment(matches[0].valormax);
    const minMoment = moment(matches[0].valormin);
    const sufijo =
      maxMoment.isValid() && maxMoment.format("L") !== minMoment.format("L")
        ? ` al ${moment(matches[0].valormax.substring(0, 10)).format(formato)}`
        : "";
    return `${inicio}${sufijo}`;
  };

  const fechaInicio = formatFechaRango("Apertura", "LL");
  const fechaFin = formatFechaRango("Cierre", "LL");

  return (
    <div className="container-background-jurados">
      <div className="subcontainer-background-participantes">
        <div className="container-fluid2">
          <div className="row">
            <div className="col-4 col-md-2 me-md-4 mt-5 mb-md-5 logo-banner-postulacion">
              {showSMImage ? (
                <Image src={ImageconvocatoriaSm} preview={false} />
              ) : (
                <Image src={Imageconvocatoria} preview={false} />
              )}
            </div>
            <div className="col-12 col-md-9 mt-5 mb-5">
              <div className="row">
                <div
                  style={{ lineHeight: "normal", paddingBottom: "2px" }}
                  className="col-12 font-family-Montserrat-Bold font-size-15px font-color-FFFFFF subtexto-sombras-general"
                >
                  Formulario de Postulación
                </div>
                <div
                  style={{ lineHeight: "normal", paddingBottom: "2px" }}
                  className="col-12 font-family-Montserrat-Bold font-size-22px font-color-FFFFFF texto-sombras-general"
                >
                  {convocatoria?.nombre_convocatoria}
                </div>
                <div
                  style={{
                    lineHeight: "normal",
                    paddingBottom: props.role === "jurados" ? "16px" : "18px",
                  }}
                  className="col-12 font-size-18px font-color-FFFFFF subtexto-sombras-general"
                >
                  {props.convocatorias && getFilterLineaConvocatoria(props.convocatorias.linea_convocatoria) !== undefined
                    ? `${getFilterLineaConvocatoria(props.convocatorias.linea_convocatoria)}`
                    : ""}
                </div>
                <div className="col-12 col-md-4 mt-2 font-family-Montserrat-Regular font-size-18px font-color-FFFFFF">
                  <span className="no-margin font-family-Montserrat-Bold">
                    ENTIDAD:
                  </span>{" "}
                  {convocatoria.entidad !== null ? convocatoria.entidad : "No tiene entidad"}
                </div>

                {props.showExpression && (
                  <div className="col-12 col-md-4 mt-2 font-family-Montserrat-Regular font-size-18px font-color-FFFFFF">
                    <span className="no-margin font-family-Montserrat-Bold">
                      EXPRESIÓN:
                    </span>{" "}
                    {convocatoria.area?.map((area: any, index: number) => {
                      if (convocatoria.area.length === index + 1) return ` ${area.value}`;
                      else return ` ${area.value},`;
                    })}
                  </div>
                )}

                <div className="col-12 col-md-4 mt-2 font-family-Montserrat-Regular font-size-18px font-color-FFFFFF">
                  <span className="no-margin font-family-Montserrat-Bold">
                    LÍNEA ESTRATÉGICA:
                  </span>{" "}
                  {convocatoria.linea_estrategica !== null
                    ? convocatoria.linea_estrategica
                    : "No tiene línea estratégica"}
                </div>
                <div className="col-12 col-md-4 mt-2 font-family-Montserrat-Regular font-size-18px font-color-FFFFFF">
                  <span className="no-margin font-family-Montserrat-Bold">
                    FECHA INICIO:
                  </span>{" "}
                  {fechaInicio}
                </div>
                <div className="col-12 col-md-4 mt-2 font-family-Montserrat-Regular font-size-18px font-color-FFFFFF">
                  <span className="no-margin font-family-Montserrat-Bold">
                    FECHA CIERRE:
                  </span>{" "}
                  {fechaFin}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
